import { Error } from "@mui/icons-material";
import { Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ErrorMessageText from "./ErrorMessageText";
interface IProps {
    message?: string,
}



const ErrorMessageContainer = (props: IProps): JSX.Element => {

    const { t, i18n } = useTranslation();

    return <Container maxWidth="md" sx={{ alignSelf: "center", justifySelf: "center" }}>
        <Stack justifyContent="center" alignItems="center">
            <Error fontSize="large" />
            <Typography>
                {t("basic.unexpectedError")}
            </Typography>
            <Typography>
                {props.message ? <ErrorMessageText message={props.message}/> : "" }
            </Typography>
        </Stack>
    </Container>

}

export default ErrorMessageContainer;